import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import styled from 'styled-components';

import {
    AprobacionStore,
    RegistroImpuestosAguaStore,
    RegistroImpuestosPredialStore
} from '../../stores';

import { Button, Icon, Row } from 'antd';
import { RegistroImpuestosAguaForm } from '../RegistroImpuestosAguaForm';
import { RegistroImpuestosPredialForm } from '../RegistroImpuestosPredialForm';
import { AprobacionHeader } from './AprobacionesHeader';
import { BotonesAprobacion } from './BotonesAprobacion';
import { TablaRevisiones } from './TablaRevisiones';

const AprobacionesWrapper = styled.div`
    margin: 0 auto;
    max-width: 1200px;
`;

const BodyRow = styled(Row)`
    padding: inherit;
`;

interface AprobacionesProps extends RouteComponentProps {
    registroImpuestosPredialStore?: RegistroImpuestosPredialStore;
    registroImpuestosAguaStore?: RegistroImpuestosAguaStore;
    aprobacionStore?: AprobacionStore;
}

@inject('aprobacionStore')
@inject('registroImpuestosPredialStore')
@inject('registroImpuestosAguaStore')
@observer
class AprobacionesInner extends React.Component<AprobacionesProps> {
    async componentDidMount() {
        this.unselect();
        const { registroImpuestosPredialStore, registroImpuestosAguaStore } = this.props;
        registroImpuestosPredialStore!.setMode('aprobaciones');
        registroImpuestosAguaStore!.setMode('aprobaciones');
    }

    displayTable = () => {
        return (
            <BodyRow>
                <TablaRevisiones />
            </BodyRow>
        );
    };

    unselect = () => {
        this.props.aprobacionStore!.unselect();
    };

    displayForm = () => {
        const { unselect } = this;
        const { aprobacionStore } = this.props;
        const { aprobar, rechazar } = aprobacionStore!;
        const { tipoImpuesto, isActed } = aprobacionStore!.selectedForm!;

        return (
            <BodyRow>
                <Button type="ghost" onClick={unselect} style={{ marginBottom: '16px' }}>
                    <Icon type="left" />
                    Atrás
                </Button>
                {tipoImpuesto === 'Agua' ? (
                    <RegistroImpuestosAguaForm />
                ) : (
                    <RegistroImpuestosPredialForm />
                )}
                {!isActed && (
                    <BotonesAprobacion handleAceptar={aprobar} handleRechazar={rechazar} />
                )}
            </BodyRow>
        );
    };

    botonIngres = () => {
        const { aprobacionStore } = this.props;
        aprobacionStore!.getIngres();
    };

    botonMunicipios = () => {
        const { aprobacionStore } = this.props;
        aprobacionStore!.getReintegro();
    };

    render() {
        const isSelected = this.props.aprobacionStore!.isSelected;
        return (
            <AprobacionesWrapper>
                <Row className="justify-content-md-center">
                    <AprobacionHeader />
                </Row>
                <Row>
                    {/* <Button onClick={this.botonIngres}>Prueba</Button>
                    <Button onClick={this.botonMunicipios}>Municipios</Button> */}
                </Row>
                <Row>{isSelected ? this.displayForm() : this.displayTable()}</Row>
            </AprobacionesWrapper>
        );
    }
}

export const Aprobaciones = withRouter(AprobacionesInner);
